import SettingsApplicationsOutlinedIcon from "@material-ui/icons/SettingsApplicationsOutlined";

export default {
  icon: SettingsApplicationsOutlinedIcon,
};
